import React, { useEffect, useState } from "react";
import { Tabs, Input, List, Card, Spin, Button } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Add this import
import "../../../config";
import CategoryAdminCard from "./CategoryAdminCard.js";

const { TabPane } = Tabs;
const { Search } = Input;

const CategoryListforAdmin = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("All");
  const [productCategory, setProductCategory] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // Add this line

  useEffect(() => {
    setLoading(true);
    checkUserActiveStatus();
    getListofProductCategory();
  }, []);

  const checkUserActiveStatus = async () => {
    const tokenString = localStorage.getItem("token");

    try {
      let config = {
        method: "get",
        url:
          global.config.APIURL.BaseURL + "api/UserAccount/GetUserAccountDetail",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
      };

      axios
        .request(config)
        .then((response) => {
          if (
            response.data.IsActive === false ||
            response.data.IsDeleted === false ||
            response.data.IsEmployee !== true // <-- Only allow if IsEmployee is true
          ) {
            alert("You are not authorized to access this page.");
            localStorage.removeItem("token");
            localStorage.removeItem("userName");
            window.location.href = "/"; // <-- Redirect to home
          }
        })
        .catch((error) => {});
    } catch (error) {}
  };

  const filteredCategory = filterByCategoryName(searchTerm.toLowerCase());

  function filterByCategoryName(searchText) {
    const lowerSearch = searchText.toLowerCase();

    return productCategory
      .map((category) => ({
        ...category,
        data: category.data.filter((item) =>
          item.CategoryName.toLowerCase().includes(lowerSearch)
        ),
      }))
      .filter((category) => category.data.length > 0); // remove empty groups
  }

  async function getListofProductCategory() {
    setLoading(true);
    const tokenString = localStorage.getItem("token");

    try {
      const listData = {
        FirmID: "1",
      };

      let config = {
        method: "get",
        url:
          global.config.APIURL.BaseURL +
          "api/ProductCategory/ListofProductCategory",
        headers: {
          Authorization: "Bearer " + tokenString,
        },
        data: listData,
      };

      axios
        .request(config)
        .then((response) => {
          setProductCategory(response.data);
          setLoading(false);
        })
        .catch((error) => {});
    } catch (err) {
      setLoading(false);
    }
  }

  const totalCount = productCategory.reduce(
    (acc, section) => acc + section.data.length,
    0
  );

  return (
    <div style={{ padding: 24 }}>
      <Card>
        <Spin tip="Loading..." spinning={loading}>
          <Tabs
            defaultActiveKey="All"
            onChange={(key) => setActiveTab(key)}
            style={{ marginBottom: 16 }}
          >
            <TabPane tab={`All (${totalCount})`} key="All" />
          </Tabs>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: 24,
              flexWrap: "wrap",
              gap: 16,
            }}
          >
            <Search
              placeholder="Search category..."
              onSearch={(value) => setSearchTerm(value)}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ maxWidth: 300 }}
              allowClear
            />
            <Button onClick={() => navigate("/ArrangeCategorySequence")}>
              Re Arrange
            </Button>
          </div>

          {/* List Layout */}
          <List
            itemLayout="horizontal"
            dataSource={filteredCategory.flatMap((category) => category.data)}
            renderItem={(category) => (
              <List.Item>
                <CategoryAdminCard category={category} />
              </List.Item>
            )}
          />
        </Spin>
      </Card>
    </div>
  );
};

export default CategoryListforAdmin;
